import { TcrLayout } from "@/tcr/TcrLayout";
import { ReceiptsGallery } from "@/tcr/ReceiptsGallery";

export default function TcrReceipts() {
    return (
        <TcrLayout>
            <ReceiptsGallery />
        </TcrLayout>
    );
}
